import { Link } from "react-router-dom";
import styles from "./Product.module.css";

const NewsBar = ({
  news,
  minimal = false,
  largeImage = false,
  isSahamdaran = false,
}) => {
  return (
    <div
      className={
        minimal
          ? styles.productBarMinimal
          : largeImage
          ? styles.productBarLarge
          : styles.productBar
      }
    >
      <Link
        to={
          window.location.href.indexOf("/retired") >= 0
            ? "/retired/news/show/" + news?.guid
            : window.location.href.indexOf("/partners") >= 0
            ? "/partners/news/show/" + news?.guid
            : window.location.href.indexOf("/vsat") >= 0
            ? "/vsat/news/show/" + news?.guid
            : "/news/show/" + news?.guid
        }
        className={styles.textDecorationNone}
      >
        <div
          className={
            largeImage
              ? styles.mainWrapperLargeContainer
              : !minimal
              ? styles.mainWrapperContainer
              : ""
          }
        >
          <div className={styles.productBarWrapper}>
            <div
              className={
                minimal
                  ? styles.productImageItemMinimal
                  : largeImage
                  ? styles.productImageItemLarge
                  : styles.productImageItem
              }
            >
              <div
                className={
                  minimal
                    ? styles.productBarImageInnerMinimal
                    : largeImage
                    ? styles.productBarImageInnerLarge
                    : styles.productBarImageInner
                }
              >
                <img
                  className={
                    Array.isArray(news?.attachment_files) &&
                    news?.attachment_files.length > 0 &&
                    !isSahamdaran
                      ? ""
                      : styles.grayScaleOne
                  }
                  src={
                    Array.isArray(news?.attachment_files) &&
                    news?.attachment_files.length > 0 &&
                    !isSahamdaran
                      ? news?.attachment_files[0].server_relative_url
                      : "/assets/image/logo.png"
                  }
                  alt={news?.title}
                />
              </div>
            </div>

            <div
              className={
                minimal
                  ? styles.productContentItemMinimal
                  : largeImage
                  ? styles.productContentItemLarge
                  : styles.productContentItem
              }
            >
              {!isSahamdaran && (
                <div className={styles.productBarContentSmallInfo}>
                  <i className={"fa fa-calendar calendar-set-item"}></i> تاریخ
                  انتشار : {news?.publish_date}
                </div>
              )}
              <div
                className={
                  minimal
                    ? styles.productBarContentMinimal
                    : styles.productBarContent
                }
              >
                {news?.title}
              </div>
              {!minimal && (
                <div
                  className={
                    largeImage
                      ? styles.productBarContentDateLarge
                      : styles.productBarContentDate
                  }
                >
                  {news?.short_description}
                </div>
              )}
              <div
                className={
                  minimal
                    ? styles.productBarMoreStudyMinimal
                    : styles.productBarMoreStudy
                }
              >
                ادامه خبر <i className="fa fa-angle-left"></i>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default NewsBar;
